module.exports = __webpack_public_path__ + "a3bc7e3f.svg";